<div class="container-fluid">
  <div class="row mt-2">
    <div class="mb-3 text-secondary col-12">
      <small class="form-text">Les champs marqués d'un <em class="text-danger">*</em> sont obligatoires. </small>
    </div>
    <div class="col-12">
      @if (personalDataForm) {
        <form [formGroup]="personalDataForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-12">
              <h5 class="text-primary">Informations personnelles</h5>
            </div>
          </div>
          <div class="row">
            <span class="col-12 col-lg-3 col-xl-1"><label class="required">Civilité</label> :</span>
            <div class="col-4 col-lg-3 col-xl-1">
              <div class="form-check form-check-inline">
                <input
                  id="madam"
                  type="radio"
                  class="form-check-input"
                  formControlName="title"
                  name="title"
                  value="Madam"
                  [class.is-invalid]="submitted && personalDataForm.controls.title?.invalid"
                />
                <label for="madam" class="custom-control-label">Mme</label>
              </div>
            </div>
            <div class="col-4 col-lg-3 col-xl-1">
              <div class="form-check form-check-inline">
                <input
                  id="mister"
                  type="radio"
                  class="form-check-input"
                  formControlName="title"
                  name="title"
                  value="Mister"
                  [class.is-invalid]="submitted && personalDataForm.controls?.title?.invalid"
                />
                <label for="mister" class="custom-control-label">M.</label>
              </div>
            </div>
            <div class="col-4 col-lg-3 col-xl-1">
              <div class="form-check form-check-inline">
                <input
                  id="unknown"
                  type="radio"
                  class="form-check-input"
                  formControlName="title"
                  name="title"
                  value="Unknown"
                  [class.is-invalid]="submitted && personalDataForm.controls?.title?.invalid"
                />
                <label for="unknown" class="custom-control-label">Inconnu</label>
              </div>
            </div>
          </div>
          @if (submitted && personalDataForm.controls?.title?.errors?.required) {
            <small class="form-text text-danger">La civilité est requise.</small>
          }
          <div class="row mt-3">
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Nom d'usage</label>
              <input
                type="text"
                class="form-control"
                formControlName="usualName"
                [class.is-invalid]="
                  (submitted && personalDataForm.controls?.usualName?.errors?.required) ||
                  (submitted && personalDataForm.controls?.usualName?.errors?.maxlength) ||
                  (submitted && personalDataForm.controls?.usualName?.errors?.pattern)
                "
              />
              @if (submitted && personalDataForm.controls?.usualName?.errors?.required) {
                <small class="form-text text-danger">Le nom d'usage est requis.</small>
              }
              @if (submitted && personalDataForm.controls?.usualName?.errors?.maxlength) {
                <small class="form-text text-danger">La taille maximale du nom d'usage est de 32 caractères.</small>
              }
              @if (submitted && personalDataForm.controls?.usualName?.errors?.pattern) {
                <small class="form-text text-danger">Les caractères spéciaux et les numéros ne sont pas autorisés.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Nom de famille</label>
              <input
                type="text"
                class="form-control"
                formControlName="surname"
                [class.is-invalid]="
                  (submitted && personalDataForm.controls?.surname?.errors?.required) ||
                  (submitted && personalDataForm.controls?.surname?.errors?.maxlength) ||
                  (submitted && personalDataForm.controls?.surname?.errors?.pattern)
                "
              />
              @if (submitted && personalDataForm.controls?.surname?.errors?.required) {
                <small class="form-text text-danger">Le nom de famille est requis.</small>
              }
              @if (submitted && personalDataForm.controls?.surname?.errors?.maxlength) {
                <small class="form-text text-danger">La taille maximale du Nom de famille est de 32 caractères.</small>
              }
              @if (submitted && personalDataForm.controls?.surname?.errors?.pattern) {
                <small class="form-text text-danger">Les caractères spéciaux et les numéros ne sont pas autorisés.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Prénom 1</label>
              <input
                type="text"
                class="form-control"
                formControlName="firstName"
                [class.is-invalid]="
                  (submitted && personalDataForm.controls?.firstName?.errors?.required) ||
                  (submitted && personalDataForm.controls?.firstName?.errors?.maxlength) ||
                  (submitted && personalDataForm.controls?.firstName?.errors?.pattern)
                "
              />
              @if (submitted && personalDataForm.controls?.firstName?.errors?.required) {
                <small class="form-text text-danger">Le prénom est requis.</small>
              }
              @if (submitted && personalDataForm.controls?.firstName?.errors?.maxlength) {
                <small class="form-text text-danger">La taille maximale du prénom 1 est de 32 caractères.</small>
              }
              @if (submitted && personalDataForm.controls?.firstName?.errors?.pattern) {
                <small class="form-text text-danger">Les caractères spéciaux et les numéros ne sont pas autorisés.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Prénom 2</label>
              <input
                type="text"
                class="form-control"
                formControlName="secondName"
                [class.is-invalid]="
                  (submitted && personalDataForm.controls?.secondName?.errors?.maxlength) ||
                  (submitted && personalDataForm.controls?.secondName?.errors?.pattern)
                "
              />
              @if (submitted && personalDataForm.controls?.secondName?.errors?.maxlength) {
                <small class="form-text text-danger">La taille maximale du prénom 2 est de 32 caractères.</small>
              }
              @if (submitted && personalDataForm.controls?.secondName?.errors?.pattern) {
                <small class="form-text text-danger">Les caractères spéciaux et les numéros ne sont pas autorisés.</small>
              }
            </div>
          </div>
          <div class="row">
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Date de naissance</label>
              <app-datepicker
                id="fieldBirthDate"
                formControlName="birthDate"
                [invalid]="submitted && personalDataForm.controls?.birthDate?.invalid"
              ></app-datepicker>
              @if (submitted && personalDataForm.controls?.birthDate?.errors?.dateFormat) {
                <small class="form-text text-danger">La date de naissance est invalide.</small>
              }
              @if (submitted && personalDataForm.controls?.birthDate?.errors?.required) {
                <small class="form-text text-danger">La date de naissance est requise.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Nationalité</label>
              <select
                class="form-select"
                formControlName="nationality"
                [class.is-invalid]="submitted && personalDataForm.controls?.nationality?.invalid"
              >
                @if (!personalDataForm.controls?.nationality.value) {
                  <option value="" selected></option>
                }
                @for (nationality of nationalities | keyvalue: stringAscOrder; track nationality) {
                  <option [ngValue]="nationality.key" [hidden]="nationality.value === 'Reprise IODAS' || nationality.value === 'Reprise ABC'">
                    {{ nationality.value }}
                  </option>
                }
              </select>
              @if (submitted && personalDataForm.controls?.nationality?.errors?.required) {
                <small class="form-text text-danger">La nationalité est requise.</small>
              }
            </div>
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label>Ville de naissance</label>
              <input
                type="text"
                #inputBirthCity
                class="form-control"
                autocomplete="off"
                formControlName="birthCity"
                [ngbTypeahead]="searchBirthCity"
                [inputFormatter]="inputFormat"
                [resultFormatter]="resultFormat"
                [editable]="false"
                [class.is-invalid]="submitted && personalDataForm.controls?.birthCity?.errors?.pattern"
                (blur)="onBlurBirthCity(inputBirthCity)"
                (selectItem)="onSelectBirthCity($event, inputBirthCity)"
                (focus)="onFocus($event)"
                #instance="ngbTypeahead"
              />
              @if (submitted && personalDataForm.controls?.birthCity?.errors?.pattern) {
                <small class="form-text text-danger">Les caractères spéciaux et les numéros ne sont pas autorisés.</small>
              }
            </div>
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label>Code postal de naissance</label>
              <input
                type="text"
                class="form-control"
                autocomplete="off"
                formControlName="birthPostalCode"
                [readonly]="true"
                [class.is-invalid]="submitted && personalDataForm.controls?.birthPostalCode?.invalid"
              />
              @if (submitted && personalDataForm.controls?.birthPostalCode?.invalid) {
                <small class="form-text text-danger">Le code postal de naissance est invalide.</small>
              }
            </div>
            @if (isCreateMode() || user.groups.includes('RECEPTION')) {
              <ng-container formGroupName="familialDataForm">
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label class="required">Situation familiale</label>
                  <select
                    class="form-select"
                    formControlName="maritalStatus"
                    [class.is-invalid]="submitted && familialDataForm.controls?.maritalStatus?.errors?.required"
                  >
                    @if (!familialDataForm.value.maritalStatus) {
                      <option [ngValue]="" selected hidden></option>
                    }
                    @for (maritalStatus of maritalStatusMap | keyvalue: stringAscOrder; track maritalStatus) {
                      <option [ngValue]="maritalStatus.key">
                        {{ maritalStatus.value }}
                      </option>
                    }
                  </select>
                  @if (submitted && familialDataForm.controls?.maritalStatus?.errors?.required) {
                    <small class="form-text text-danger">La situation familiale est requise.</small>
                  }
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label>Nombre d'enfants</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="childrenCount"
                    maxlength="2"
                    [class.is-invalid]="submitted && familialDataForm.controls?.childrenCount?.errors?.pattern"
                  />
                  @if (submitted && familialDataForm.controls?.childrenCount?.errors?.pattern) {
                    <small class="form-text text-danger">Seuls les nombres sont autorisés.</small>
                  }
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label>Nombre de personnes à charge</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="dependentsNumber"
                    maxlength="2"
                    [class.is-invalid]="submitted && familialDataForm.controls?.dependentsNumber?.errors?.pattern"
                  />
                  @if (submitted && familialDataForm.controls?.dependentsNumber?.errors?.pattern) {
                    <small class="form-text text-danger">Seuls les nombres sont autorisés.</small>
                  }
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label class="required">Parent isolé </label>
                  <div class="mt-1">
                    <div class="form-check form-check-inline">
                      <input
                        id="singleParentYes"
                        type="radio"
                        class="form-check-input"
                        formControlName="singleParent"
                        name="singleParent"
                        [class.is-invalid]="submitted && familialDataForm.controls.singleParent.invalid"
                        [value]="true"
                      />
                      <label for="singleParentYes" class="form-check-label">Oui</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        id="singleParentNo"
                        type="radio"
                        class="form-check-input"
                        formControlName="singleParent"
                        name="singleParent"
                        [class.is-invalid]="submitted && familialDataForm.controls.singleParent.invalid"
                        [value]="false"
                      />
                      <label for="singleParentNo" class="form-check-label">Non</label>
                    </div>
                    @if (submitted && familialDataForm.controls?.singleParent?.errors?.required) {
                      <small class="form-text text-danger">Ce champ est requis</small>
                    }
                  </div>
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label>Couverture santé</label>
                  <select class="form-select" formControlName="healthInsuranceId">
                    @if (!familialDataForm.value.healthInsuranceId) {
                      <option [ngValue]="" selected hidden></option>
                    }
                    <option [ngValue]=""></option>
                    @for (healthInsurance of healthInsurances; track healthInsurance) {
                      <option [ngValue]="healthInsurance.id">
                        {{ healthInsurance.label }}
                      </option>
                    }
                  </select>
                </div>
              </ng-container>
            }
          </div>
          <div class="row mt-4">
            <div class="col">
              <h5 class="text-primary">Adresse de résidence</h5>
            </div>
          </div>
          <div class="row" formGroupName="addressForm">
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label class="required">Début à cette adresse</label>
              <app-datepicker
                id="fieldBeginDate"
                formControlName="beginDate"
                [invalid]="
                  (submitted || residentialAddressHistorized) && (addressForm.controls?.beginDate?.invalid || addressForm.errors?.datesOrder)
                "
              ></app-datepicker>
              @if ((submitted || residentialAddressHistorized) && addressForm.controls?.beginDate?.errors?.dateFormat) {
                <small class="form-text text-danger">La date de début d'adresse est invalide.</small>
              }
              @if ((submitted || residentialAddressHistorized) && addressForm.controls?.beginDate?.errors?.required) {
                <small class="form-text text-danger">La date de début d'adresse est requise.</small>
              }
              @if ((submitted || residentialAddressHistorized) && addressForm.errors?.datesOrder) {
                <small class="form-text text-danger">La date de début est incohérente avec la date de fin.</small>
              }
            </div>
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label>Fin</label>
              <app-datepicker
                id="fieldEndDate"
                formControlName="endDate"
                [invalid]="(submitted || residentialAddressHistorized) && (addressForm.controls?.endDate?.invalid || addressForm.errors?.datesOrder)"
              ></app-datepicker>
              @if (residentialAddressHistorized && addressForm?.get('endDate')?.hasError('required')) {
                <small class="form-text text-danger">La date de fin d'adresse est requise pour historiser.</small>
              }
              @if ((submitted || residentialAddressHistorized) && addressForm.errors?.datesOrder) {
                <small class="form-text text-danger">La date de fin est incohérente avec la date de début.</small>
              }
            </div>
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label>Statut d'habitation</label>
              <select class="form-select" formControlName="residentialStatus">
                @if (!addressForm?.value?.residentialStatus) {
                  <option [ngValue]="" selected hidden></option>
                }
                @for (residentialStatus of residentialStatusMap; track residentialStatus) {
                  <option [ngValue]="residentialStatus.key" [hidden]="residentialStatus.key === 'HostedByAThird'">
                    {{ residentialStatus.value }}
                  </option>
                }
              </select>
            </div>
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label>Complément de statut</label>
              <input type="text" class="form-control" formControlName="residentialStatusComplement" placeholder="Chez, Foyer, ..." />
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Adresse de résidence</label>
              <input
                type="text"
                class="form-control"
                formControlName="address"
                [class.is-invalid]="(submitted || residentialAddressHistorized) && addressForm.controls?.address?.errors?.required"
              />
              @if ((submitted || residentialAddressHistorized) && addressForm.controls?.address?.errors?.required) {
                <small class="form-text text-danger">L'adresse est requise.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Complément d'adresse</label>
              <input type="text" class="form-control" formControlName="additionalAddress" placeholder="Bâtiment, BP, ..." />
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Ville</label>
              <input
                #input
                type="text"
                class="form-control"
                autocomplete="ooff"
                formControlName="city"
                [ngbTypeahead]="search"
                [inputFormatter]="inputFormat"
                [resultFormatter]="resultFormat"
                [editable]="false"
                (selectItem)="onSelectItem($event, input)"
                (blur)="onBlur(input)"
                [class.is-invalid]="
                  ((submitted || residentialAddressHistorized) && addressForm.controls?.city?.errors?.required) ||
                  ((submitted || residentialAddressHistorized) && addressForm.controls?.city?.errors?.pattern)
                "
              />
              @if ((submitted || residentialAddressHistorized) && addressForm.controls?.city?.errors?.required) {
                <small class="form-text text-danger">La ville est requise.</small>
              }
              @if ((submitted || residentialAddressHistorized) && addressForm.controls?.city?.errors?.pattern) {
                <small class="form-text text-danger">Les caractères spéciaux et les numéros ne sont pas autorisés.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Code postal</label>
              <input type="text" class="form-control" formControlName="postalCode" [readonly]="true" />
            </div>
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label>CLI</label>
              <select class="form-select" formControlName="cliId">
                @if (!addressForm.value.cliId) {
                  <option [ngValue]="" selected hidden></option>
                }
                <option [ngValue]=""></option>
                @for (cli of clis; track cli) {
                  <option [ngValue]="cli.id">
                    {{ cli.label }}
                  </option>
                }
              </select>
            </div>
            <div
              class="mb-3 text-secondary col-12 col-lg-12 col-xl-3"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']"
            >
              <label>CTM</label>
              <input type="text" class="form-control" formControlName="ctmLabel" [readonly]="true" />
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label for="qpvId" class="required">Quartier QPV / QVA</label>
              <select id="qpvId" class="form-select" formControlName="qpvId">
                <option [ngValue]="-1">Hors QPV</option>
                <option disabled>──────────</option>
                @for (qpv of qpvs; track qpv) {
                  <option [ngValue]="qpv.id">
                    {{ qpv.label }}
                  </option>
                }
              </select>
              @if ((submitted || residentialAddressHistorized) && addressForm.controls?.qpvId?.errors?.required) {
                <small class="form-text text-danger"> Le champ est requis. </small>
              }
            </div>
            @if (!isCreateMode() && !differentStructure) {
              <div class="d-grid mb-3 col-12 col-lg-12 col-xl-3 mt-4">
                <button
                  class="btn btn-primary d-flex justify-content-center"
                  type="button"
                  *appOnlyGroups="['ADMIN', 'TERRITORY', 'STRUCTURE', 'DIRECTION+']"
                  (click)="historizeAddress('residential')"
                  style="margin-top: 1px"
                >
                  Historiser l'adresse
                </button>
              </div>
            }
          </div>
          <!-- Tableau historique des addresses de résidence -->
          @if (!isCreateMode()) {
            <div class="card border-0 card-border-radius-0">
              <div class="card-body p-0">
                <div class="table-responsive">
                  <div ngbAccordion [closeOthers]="false">
                    <div ngbAccordionItem>
                      <h2 ngbAccordionHeader>
                        <button ngbAccordionButton class="accordion-button text-secondary">
                          <span id="residentialHistoryTitle">Adresses de résidence historisées</span>
                        </button>
                      </h2>
                      <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                          <ng-template>
                            @if (residentialAddressHistories.length === 0) {
                              <p>Le bénéficiaire n'a aucune historisation d'adresse de résidence.</p>
                            }
                            @if (residentialAddressHistories.length !== 0) {
                              <div class="col px-0 pt-2">
                                <div class="table-responsive">
                                  <table class="table table-striped table-hover" aria-describedby="residentialHistoryTitle">
                                    <thead class="text-secondary bg-light">
                                      <tr>
                                        <th scope="col" class="text-center"></th>
                                        <th scope="col" class="text-center">Début</th>
                                        <th scope="col" class="text-center">Fin</th>
                                        <th scope="col" class="text-center">Adresse</th>
                                        <th scope="col" class="text-center">Complément</th>
                                        <th scope="col" class="text-center">Code postal</th>
                                        <th scope="col" class="text-center">Ville</th>
                                        <th scope="col" class="text-center">CLI</th>
                                        <th scope="col" class="text-center">CTM</th>
                                        <th scope="col" class="text-center">QPV / QVA</th>
                                        <th scope="col" class="text-center">Statut d'habitation</th>
                                        <th scope="col" class="text-center">Complément de statut</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (addressHistory of residentialAddressHistories; track addressHistory) {
                                        <tr>
                                          <td class="text-center">
                                            <button
                                              [style.display]="addressHistory.id ? 'block' : 'none'"
                                              type="button"
                                              (click)="deleteAddressHistory(addressHistory, 'residential')"
                                              *appOnlyGroups="['ADMIN']"
                                              class="btn btn-sm btn-primary"
                                              ngbTooltip="Supprimer"
                                            >
                                              <fa-icon icon="trash-alt"></fa-icon>
                                            </button>
                                          </td>
                                          <td class="text-center">
                                            {{ addressHistory.beginDate | date }}
                                          </td>
                                          <td class="text-center">
                                            {{ addressHistory.endDate | date }}
                                          </td>
                                          <td class="text-center">{{ addressHistory.address }}</td>
                                          <td class="text-center">
                                            {{ addressHistory.additionalAddress }}
                                          </td>
                                          <td class="text-center">{{ addressHistory.postalCode }}</td>
                                          <td class="text-center">{{ addressHistory.city }}</td>
                                          <td class="text-center">{{ getCliLabel(addressHistory.cliId) }}</td>
                                          <td class="text-center">{{ getCtmLabel(addressHistory.ctmId) }}</td>
                                          <td class="text-center">{{ addressHistory.qpvLabel ?? 'Hors QPV' }}</td>
                                          <td class="text-center">
                                            {{ residentialStatusLabel[addressHistory.residentialStatus] }}
                                          </td>
                                          <td class="text-center">
                                            {{ addressHistory.residentialStatusComplement }}
                                          </td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            }
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="mx-1 my-3" *appOnlyGroups="['TERRITORY', 'STRUCTURE', 'DIRECTION+']">
            @if (residentialAddressHistoryInvalid) {
              <small class="form-text text-danger"
                >L'historisation de l'adresse du bénéficiaire est invalide, veuillez contacter un administrateur.</small
              >
            }
          </div>
          <div class="mx-1 my-3" *appOnlyGroups="['ADMIN']">
            @if (residentialAddressHistoryInvalid) {
              <small class="form-text text-danger"
                >L'historisation de l'adresse du bénéficiaire est invalide, veuillez supprimer les lignes incohérentes et re-créer l'historisation à
                l'aide de l'adresse actuelle.</small
              >
            }
          </div>
          <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
            <div class="row mt-4">
              <div class="col">
                <h5 class="text-primary">Adresse postale</h5>
              </div>
            </div>
            <div class="row">
              <p class="col-6">Adresse de réception du courrier identique à l'adresse de résidence :</p>
              <div class="col-1">
                <div class="form-check form-check-inline">
                  <input
                    id="identicalPostalAddress"
                    type="radio"
                    class="form-check-input"
                    formControlName="identicalPostalAddress"
                    name="identicalPostalAddress"
                    [value]="true"
                    [class.is-invalid]="submitted && personalDataForm.controls.identicalPostalAddress?.invalid"
                  />
                  <label for="identicalPostalAddress" class="custom-control-label">Oui</label>
                </div>
              </div>
              <div class="col-1">
                <div class="form-check form-check-inline">
                  <input
                    id="differentPostalAddress"
                    type="radio"
                    class="form-check-input"
                    formControlName="identicalPostalAddress"
                    name="identicalPostalAddress"
                    [value]="false"
                    [class.is-invalid]="submitted && personalDataForm.controls?.identicalPostalAddress?.invalid"
                  />
                  <label for="differentPostalAddress" class="custom-control-label">Non</label>
                </div>
              </div>
            </div>
            <div class="row" formGroupName="postalAddressForm">
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label class="required">Début à cette adresse</label>
                <app-datepicker
                  id="postalBeginDate"
                  formControlName="postalBeginDate"
                  [invalid]="
                    (submitted || postalAddressHistorized) &&
                    (postalAddressForm.controls?.postalBeginDate?.invalid || postalAddressForm.errors?.datesOrder)
                  "
                ></app-datepicker>
                @if ((submitted || postalAddressHistorized) && postalAddressForm.controls?.postalBeginDate?.errors?.dateFormat) {
                  <small class="form-text text-danger">La date de début d'adresse est invalide.</small>
                }
                @if ((submitted || postalAddressHistorized) && postalAddressForm.controls?.postalBeginDate?.errors?.required) {
                  <small class="form-text text-danger">La date de début d'adresse est requise.</small>
                }
                @if ((submitted || postalAddressHistorized) && postalAddressForm.errors?.datesOrder) {
                  <small class="form-text text-danger">La date de début est incohérente avec la date de fin.</small>
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label>Fin</label>
                <app-datepicker
                  id="postalEndDate"
                  formControlName="postalEndDate"
                  [invalid]="
                    (submitted || postalAddressHistorized) &&
                    (postalAddressForm.controls?.postalEndDate?.invalid || postalAddressForm.errors?.datesOrder)
                  "
                ></app-datepicker>
                @if (postalAddressForm.get('postalEndDate').hasError('required')) {
                  <small class="form-text text-danger">La date de fin d'adresse est requise pour historiser.</small>
                }
                @if ((submitted || postalAddressHistorized) && postalAddressForm.errors?.datesOrder) {
                  <small class="form-text text-danger">La date de fin est incohérente avec la date de début.</small>
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label class="required">Type de domiciliation</label>
                <select
                  class="form-select"
                  formControlName="domiciliationType"
                  [class.is-invalid]="(submitted || postalAddressHistorized) && postalAddressForm.controls?.domiciliationType?.errors?.required"
                >
                  @for (domiciliationType of domiciliationTypeMap; track domiciliationType) {
                    <option [ngValue]="domiciliationType.key">
                      {{ domiciliationType.value }}
                    </option>
                  }
                </select>
                @if ((submitted || postalAddressHistorized) && postalAddressForm.controls?.domiciliationType?.errors?.required) {
                  <small class="form-text text-danger">Le type de domiciliation est requis.</small>
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label>Complément de domiciliation</label>
                <input type="text" class="form-control" formControlName="domiciliationTypeComplement" placeholder="Nom d'association, CCAS" />
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label class="required">Adresse postale</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="postalAddress"
                  [class.is-invalid]="(submitted || postalAddressHistorized) && postalAddressForm.controls?.postalAddress?.errors?.required"
                />
                @if ((submitted || postalAddressHistorized) && postalAddressForm.controls?.postalAddress?.errors?.required) {
                  <small class="form-text text-danger">L'adresse est requise.</small>
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label>Complément d'adresse</label>
                <input type="text" class="form-control" formControlName="postalAdditionalAddress" placeholder="Bâtiment, BP, ..." />
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label class="required">Ville</label>
                <input
                  #inputPostalCity
                  type="text"
                  class="form-control"
                  autocomplete="ooff"
                  formControlName="postalCity"
                  [ngbTypeahead]="searchPostalCity"
                  [inputFormatter]="inputFormat"
                  [resultFormatter]="resultFormat"
                  [editable]="false"
                  (selectItem)="onSelectPostalCity($event, inputPostalCity)"
                  (blur)="onBlurPostalCity(inputPostalCity)"
                  [class.is-invalid]="
                    ((submitted || postalAddressHistorized) && postalAddressForm.controls?.postalCity?.errors?.required) ||
                    ((submitted || postalAddressHistorized) && postalAddressForm.controls?.postalCity?.errors?.pattern)
                  "
                />
                @if ((submitted || postalAddressHistorized) && postalAddressForm.controls?.postalCity?.errors?.required) {
                  <small class="form-text text-danger">La ville est requise.</small>
                }
                @if ((submitted || postalAddressHistorized) && postalAddressForm.controls?.postalCity?.errors?.pattern) {
                  <small class="form-text text-danger">Les caractères spéciaux et les numéros ne sont pas autorisés.</small>
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label class="required">Code postal</label>
                <input type="text" class="form-control" formControlName="postalPostalCode" [readonly]="true" />
              </div>
              @if (!isCreateMode() && personalDataForm.controls.identicalPostalAddress.value !== true && !differentStructure) {
                <div class="d-grid mb-3 col-12 col-lg-12 col-xl-3 mt-4 ms-auto">
                  <button
                    class="btn btn-primary d-flex justify-content-center"
                    type="button"
                    *appOnlyGroups="['ADMIN', 'TERRITORY', 'STRUCTURE', 'DIRECTION+']"
                    (click)="historizeAddress('postal')"
                    style="margin-top: 1px"
                  >
                    Historiser l'adresse
                  </button>
                </div>
              }
            </div>
            @if (!isCreateMode()) {
              <div class="card border-0 card-border-radius-0">
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <div ngbAccordion [closeOthers]="false">
                      <div ngbAccordionItem>
                        <h2 ngbAccordionHeader>
                          <button ngbAccordionButton class="accordion-button text-secondary">
                            <span id="postalHistoryTitle">Adresses postales historisées</span>
                          </button>
                        </h2>
                        <div ngbAccordionCollapse>
                          <div ngbAccordionBody>
                            <ng-template>
                              @if (postalAddressHistories.length === 0) {
                                <p>Le bénéficiaire n'a aucune historisation d'adresse postale.</p>
                              }
                              @if (postalAddressHistories.length !== 0) {
                                <div class="col px-0 pt-2">
                                  <div class="table-responsive">
                                    <table class="table table-striped table-hover" aria-describedby="postalHistoryTitle">
                                      <thead class="text-secondary bg-light">
                                        <tr>
                                          <th scope="col" class="text-center"></th>
                                          <th scope="col" class="text-center">Début</th>
                                          <th scope="col" class="text-center">Fin</th>
                                          <th scope="col" class="text-center">Adresse</th>
                                          <th scope="col" class="text-center">Complément</th>
                                          <th scope="col" class="text-center">Code postal</th>
                                          <th scope="col" class="text-center">Ville</th>
                                          <th scope="col" class="text-center">Type de domiciliation</th>
                                          <th scope="col" class="text-center">Complément de domiciliation</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        @for (postalAddressHistory of postalAddressHistories; track postalAddressHistory) {
                                          <tr>
                                            <td class="text-center">
                                              <button
                                                [style.display]="postalAddressHistory.id ? 'block' : 'none'"
                                                type="button"
                                                (click)="deleteAddressHistory(postalAddressHistory, 'postal')"
                                                *appOnlyGroups="['ADMIN']"
                                                class="btn btn-sm btn-primary"
                                                ngbTooltip="Supprimer"
                                              >
                                                <fa-icon icon="trash-alt"></fa-icon>
                                              </button>
                                            </td>
                                            <td class="text-center">
                                              {{ postalAddressHistory.beginDate | date }}
                                            </td>
                                            <td class="text-center">
                                              {{ postalAddressHistory.endDate | date }}
                                            </td>
                                            <td class="text-center">
                                              {{ postalAddressHistory.address }}
                                            </td>
                                            <td class="text-center">
                                              {{ postalAddressHistory.additionalAddress }}
                                            </td>
                                            <td class="text-center">
                                              {{ postalAddressHistory.postalCode }}
                                            </td>
                                            <td class="text-center">
                                              {{ postalAddressHistory.city }}
                                            </td>
                                            <td class="text-center">
                                              {{ domiciliationTypeLabel[postalAddressHistory.domiciliationType] }}
                                            </td>
                                            <td class="text-center">
                                              {{ postalAddressHistory.domiciliationTypeComplement }}
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              }
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="mx-1 my-3" *appOnlyGroups="['TERRITORY', 'STRUCTURE', 'DIRECTION+']">
              @if (postalAddressHistoryInvalid) {
                <small class="form-text text-danger"
                  >L'historisation de l'adresse postale du bénéficiaire est invalide, veuillez contacter un administrateur.</small
                >
              }
            </div>
            <div class="mx-1 my-3" *appOnlyGroups="['ADMIN']">
              @if (postalAddressHistoryInvalid) {
                <small class="form-text text-danger"
                  >L'historisation de l'adresse postale du bénéficiaire est invalide, veuillez supprimer les lignes incohérentes et re-créer
                  l'historisation à l'aide de l'adresse actuelle.</small
                >
              }
            </div>
          </ng-container>
          <div class="row mt-4">
            <div class="col">
              <h5 class="text-primary">Informations de contact</h5>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Numéro téléphone fixe</label>
              <input
                type="text"
                class="form-control"
                formControlName="landlineNumber"
                [class.is-invalid]="
                  (submitted && personalDataForm.controls?.landlineNumber?.errors?.maxlength) ||
                  (submitted && personalDataForm.controls?.landlineNumber?.errors?.minlength) ||
                  (submitted && personalDataForm.controls?.landlineNumber?.errors?.pattern)
                "
              />
              @if (
                (submitted && personalDataForm.controls?.landlineNumber?.errors?.maxlength) ||
                (submitted && personalDataForm.controls?.landlineNumber?.errors?.minlength) ||
                (submitted && personalDataForm.controls?.landlineNumber?.errors?.pattern)
              ) {
                <small class="form-text text-danger">Le numéro de téléphone fixe est composé de 10 chiffres.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Numéro téléphone mobile</label>
              <input
                type="text"
                class="form-control"
                formControlName="cellPhoneNumber"
                [class.is-invalid]="
                  (submitted && personalDataForm.controls?.cellPhoneNumber?.errors?.maxlength) ||
                  (submitted && personalDataForm.controls?.cellPhoneNumber?.errors?.minlength) ||
                  (submitted && personalDataForm.controls?.cellPhoneNumber?.errors?.pattern)
                "
              />
              @if (
                (submitted && personalDataForm.controls?.cellPhoneNumber?.errors?.maxlength) ||
                (submitted && personalDataForm.controls?.cellPhoneNumber?.errors?.minlength) ||
                (submitted && personalDataForm.controls?.cellPhoneNumber?.errors?.pattern)
              ) {
                <small class="form-text text-danger">Le numéro de téléphone mobile est composé de 10 chiffres.</small>
              }
              <div class="form-check form-check-inline">
                <input id="authorize-sms" type="checkbox" class="form-check-input" formControlName="sms" />
                <label class="custom-control-label" for="authorize-sms">Autorisation SMS</label>
              </div>
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Adresse email</label>
              <input
                type="text"
                class="form-control"
                formControlName="emailAddress"
                [class.is-invalid]="submitted && personalDataForm.controls?.emailAddress?.errors?.email"
              />
              @if (submitted && personalDataForm.controls?.emailAddress?.errors?.email) {
                <small class="form-text text-danger">L'adresse mail est invalide.</small>
              }
              <div class="form-check form-check-inline">
                <input id="authorize-email" type="checkbox" class="form-check-input" formControlName="email" />
                <label class="custom-control-label" for="authorize-email">Autorisation Email</label>
              </div>
            </div>
          </div>
          <ng-container *appOnlyGroups="['RECEPTION']">
            <div class="row mt-4">
              <div class="col">
                <h5 class="text-primary">Situation initiale *</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-4 col-lg-2">
                <div class="form-check">
                  <input
                    id="isEmployee"
                    type="checkbox"
                    class="form-check-input"
                    formControlName="isEmployee"
                    name="isEmployee"
                    [class.is-invalid]="submitted && personalDataForm.errors?.situationRequired"
                  />
                  <label class="form-check-label" for="isEmployee">Salarié</label>
                </div>
              </div>
              <div class="col-4 col-lg-2">
                <div class="form-check">
                  <input
                    id="isJobSeeker"
                    type="checkbox"
                    class="form-check-input"
                    formControlName="isJobSeeker"
                    name="isJobSeeker"
                    [class.is-invalid]="submitted && personalDataForm.errors?.situationRequired"
                  />
                  <label for="isJobSeeker" class="form-check-label">Demandeur d'emploi</label>
                </div>
              </div>
              <div class="col-4 col-lg-2">
                <div class="form-check">
                  <input
                    id="isIndependent"
                    type="checkbox"
                    class="form-check-input"
                    formControlName="isIndependent"
                    name="isIndependent"
                    [class.is-invalid]="submitted && personalDataForm.errors?.situationRequired"
                  />
                  <label for="isIndependent" class="form-check-label">Indépendant</label>
                </div>
              </div>
              <div class="col-4 col-lg-2">
                <div class="form-check">
                  <input
                    id="isStudent"
                    type="checkbox"
                    class="form-check-input"
                    formControlName="isStudent"
                    name="isStudent"
                    [class.is-invalid]="submitted && personalDataForm.errors?.situationRequired"
                  />
                  <label for="isStudent" class="form-check-label">Etudiant</label>
                </div>
              </div>
              <div class="col-4 col-lg-2">
                <div class="form-check">
                  <input
                    id="inTraining"
                    type="checkbox"
                    class="form-check-input"
                    formControlName="inTraining"
                    name="inTraining"
                    [class.is-invalid]="submitted && personalDataForm.errors?.situationRequired"
                  />
                  <label for="inTraining" class="form-check-label">En formation</label>
                </div>
              </div>
              <div class="col-4 col-lg-2">
                <div class="form-check">
                  <input
                    id="isOther"
                    type="checkbox"
                    class="form-check-input"
                    formControlName="isOther"
                    name="isOther"
                    [class.is-invalid]="submitted && personalDataForm.errors?.situationRequired"
                  />
                  <label for="isOther" class="form-check-label">Autre</label>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              @if (submitted && personalDataForm.errors?.situationRequired) {
                <small class="form-text text-danger mt-0">La situation initiale est requise.</small>
              }
            </div>
            <div class="row">
              <div class="mb-3 text-secondary col-6 col-lg-6 col-xl-3">
                <label class="required">En accompagnement</label>
                <div class="mb-3 text-secondary">
                  <div class="row justify-content-start my-2">
                    <div class="col-3">
                      <div class="form-check form-check-inline">
                        <input
                          id="sYes"
                          type="radio"
                          class="form-check-input"
                          formControlName="supportStatus"
                          name="supportStatus"
                          [class.is-invalid]="submitted && personalDataForm.controls.supportStatus.invalid"
                          [value]="true"
                        />
                        <label for="sYes" class="form-check-label">Oui</label>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="form-check form-check-inline">
                        <input
                          id="sNo"
                          type="radio"
                          class="form-check-input"
                          formControlName="supportStatus"
                          name="supportStatus"
                          [class.is-invalid]="submitted && personalDataForm.controls.supportStatus.invalid"
                          [value]="false"
                        />
                        <label for="sNo" class="form-check-label">Non</label>
                      </div>
                    </div>
                  </div>
                  @if (submitted && personalDataForm.controls?.supportStatus?.errors?.required) {
                    <small class="form-text text-danger">L'état de l'accompagnement est requis.</small>
                  }
                </div>
              </div>
              <div class="mb-3 text-secondary col-6 col-lg-6 col-xl-6">
                <label for="support-types" [class.required]="personalDataForm.controls?.supportStatus?.value">Si oui</label>
                <div class="mb-3 text-secondary">
                  <ng-select
                    id="support-types"
                    formControlName="supportStatusTypeIds"
                    [items]="supportStatusTypes"
                    bindValue="id"
                    bindLabel="label"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    groupBy="category"
                    [selectableGroup]="true"
                    [selectableGroupAsModel]="false"
                    [class.is-invalid]="submitted && personalDataForm.controls?.supportStatusTypeIds?.invalid"
                  ></ng-select>
                </div>
                @if (submitted && personalDataForm.controls?.supportStatusTypeIds?.errors?.required) {
                  <small class="form-text text-danger">Une valeur est requise.</small>
                }
              </div>
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Orienté par</label>
              <select
                class="form-select"
                formControlName="orientedBy"
                [class.is-invalid]="submitted && personalDataForm.controls?.orientedBy?.invalid"
              >
                @if (!personalDataForm.controls?.orientedBy.value) {
                  <option value="" selected></option>
                }
                @for (orientedBy of orientedByList | keyvalue: stringAscOrder; track orientedBy) {
                  <option [ngValue]="orientedBy.key">
                    {{ orientedBy.value }}
                  </option>
                }
              </select>
              @if (submitted && personalDataForm.controls?.orientedBy?.errors?.required) {
                <small class="form-text text-danger">L'origine de l'orientation est requise.</small>
              }
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Suivi par</label>
              <input
                type="text"
                class="form-control"
                formControlName="followedBy"
                maxlength="30"
                [class.is-invalid]="submitted && personalDataForm.controls?.followedBy?.errors?.maxlength"
              />
              @if (submitted && personalDataForm.controls?.followedBy?.errors?.maxlength) {
                <small class="form-text text-danger">L'entrée est limitée à 30 caractères.</small>
              }
            </div>
          </ng-container>
          <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
            <div class="row mt-4">
              <div class="col">
                <h5 class="text-primary">Informations sociales</h5>
              </div>
            </div>
            <div class="row">
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label>Organisme payeur</label>
                <select class="form-select" formControlName="attachedOrganization">
                  <option [ngValue]=""></option>
                  @for (attachedOrganization of attachedOrganizations | keyvalue: stringAscOrder; track attachedOrganization) {
                    <option [ngValue]="attachedOrganization.key">
                      {{ attachedOrganization.value }}
                    </option>
                  }
                </select>
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label>Numéro d'allocataire (CAF/MSA)</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="recipientNumber"
                  [class.is-invalid]="submitted && personalDataForm.controls?.recipientNumber?.errors?.maxlength"
                />
                @if (submitted && personalDataForm.controls?.recipientNumber?.errors?.maxlength) {
                  <small class="form-text text-danger">La taille maximale du numéro d'allocataire est 20 caractères.</small>
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label>Numéro France Travail</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="jobCenterNumber"
                  [class.is-invalid]="submitted && personalDataForm.controls?.jobCenterNumber?.errors?.pattern"
                />
                @if (submitted && personalDataForm.controls?.jobCenterNumber?.errors?.pattern) {
                  <small class="form-text text-danger">Le numéro France Travail est composé de 8 ou 11 caractères.</small>
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                <label>Dernière inscription FT</label>
                <app-datepicker
                  id="fieldlastUpdateDate"
                  formControlName="lastUpdateDate"
                  [invalid]="submitted && personalDataForm.controls?.lastUpdateDate?.invalid"
                >
                </app-datepicker>
                @if (submitted && personalDataForm.controls?.lastUpdateDate?.errors?.dateFormat) {
                  <small class="form-text text-danger">La date de dernière inscription FT est invalide.</small>
                }
              </div>
              @if (this.user.groups.includes('ADMIN')) {
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label>N° IODAS</label>
                  <input type="text" class="form-control" formControlName="iodasNumber" />
                </div>
              }
              @if (isCreateMode() && this.user.groups.includes('ADMIN')) {
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label>Date début droit RSA</label>
                  <app-datepicker
                    id="fieldbeginRsaDate"
                    formControlName="beginRsaDate"
                    [invalid]="submitted && personalDataForm.controls?.beginRsaDate?.invalid"
                  >
                  </app-datepicker>
                  @if (submitted && personalDataForm.controls?.beginRsaDate?.errors?.dateFormat) {
                    <small class="form-text text-danger">La date début droit RSA est invalide.</small>
                  }
                </div>
              }
            </div>
            @if (isCreateMode()) {
              <div class="row mt-4">
                <div class="col">
                  <h5 class="text-primary">Accompagnement</h5>
                </div>
              </div>
            }
            @if (isCreateMode()) {
              <div class="row" formGroupName="supportForm">
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label class="required">Statut du dossier</label>
                  <select
                    class="form-select"
                    formControlName="status"
                    [class.is-invalid]="submitted && supportForm.controls?.status?.errors?.required"
                  >
                    @if (!supportForm.value.status) {
                      <option [ngValue]="" selected hidden></option>
                    }
                    @for (status of folderStatusMap | keyvalue: stringAscOrder; track status) {
                      <option [ngValue]="status.key">
                        {{ status.value }}
                      </option>
                    }
                  </select>
                  @if (submitted && supportForm.controls?.status?.errors?.required) {
                    <small class="form-text text-danger">Le statut du dossier est requis.</small>
                  }
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label class="required">Type</label>
                  <select
                    class="form-select"
                    formControlName="supportTypeId"
                    [class.is-invalid]="submitted && personalDataForm.controls.supportForm.controls.supportTypeId?.invalid"
                  >
                    @if (!personalDataForm.controls.supportForm.value.supportTypeId) {
                      <option [ngValue]="" selected hidden></option>
                    }
                    @for (supportType of supportTypes; track supportType) {
                      <option [ngValue]="supportType.id">
                        {{ supportType.label }}
                      </option>
                    }
                  </select>
                  @if (submitted && supportForm.controls?.supportTypeId?.errors?.required) {
                    <small class="form-text text-danger">Le type d'accompagnement est requis.</small>
                  }
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label class="required">Début</label>
                  <app-datepicker
                    id="fieldBeginDateSupport"
                    formControlName="beginDateSupport"
                    [invalid]="submitted && supportForm.controls?.beginDateSupport?.invalid"
                  ></app-datepicker>
                  @if (submitted && supportForm.controls?.beginDateSupport?.errors?.dateFormat) {
                    <small class="form-text text-danger">La date de début d'accompagnement est invalide.</small>
                  }
                  @if (submitted && supportForm.controls?.beginDateSupport?.errors?.required) {
                    <small class="form-text text-danger">La date de début d'accompagnement est requise.</small>
                  }
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                  <label>Détail</label>
                  <input type="text" class="form-control" formControlName="typeSupportDetail" />
                </div>
              </div>
            }
          </ng-container>
          <!-- Boutons actions -->
          <div class="row mx-0 my-3">
            <div class="d-grid ms-auto col-md-6 col-3 col-lg-3 col-xl-2 px-0" *appProfilePerimeter>
              <button
                class="btn btn-primary d-flex justify-content-center"
                type="button"
                (click)="cancel()"
                *appOnlyGroups="['ADMIN', 'TERRITORY', 'STRUCTURE', 'DIRECTION+', 'RECEPTION']"
              >
                <fa-icon icon="ban"></fa-icon>
                <span class="ms-2 d-none d-md-block">Annuler</span>
              </button>
            </div>
            <div class="d-grid col-3 col-md-6 col-lg-3 col-xl-2 pe-0" *appProfilePerimeter>
              <button
                class="btn btn-primary d-flex justify-content-center"
                type="submit"
                *appOnlyGroups="['ADMIN', 'TERRITORY', 'STRUCTURE', 'DIRECTION+', 'RECEPTION']"
              >
                <fa-icon icon="save"></fa-icon>
                <span class="ms-2 d-none d-md-block">Sauvegarder</span>
              </button>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
